import {SHIPPING_LABELS_DOWNLOAD_URL} from "../config";
import {getAccessToken} from "./api/AuthApi";

const ShippingLabelStorage = {

  getUrl(orderId, trackingNr) {
    var url = SHIPPING_LABELS_DOWNLOAD_URL.replace(":order_id", orderId);
    url = url.replace(":tracking_nr", trackingNr);
    return url;
  },

  download(url) {
    let token = getAccessToken()
    let url_with_token = `${url}?token=${token}`;
    window.open(url_with_token, "_self");
  }

}

export default ShippingLabelStorage;